import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { DocumentTemplate } from "../../models/ConsentDocument";
import { createDocumentTemplate, deleteDocumentTemplate, fetchDocumentTemplates, updateDocumentTemplate } from "./actions";

interface TemplateState {
    templates: DocumentTemplate[],
    isLoading: boolean,
    error: string | null,
}

const initialState: TemplateState = {
    templates: [],
    isLoading: false,
    error: null,
}

// slice
const templatesSlice = createSlice({
    name: "templates",
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDocumentTemplates.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchDocumentTemplates.fulfilled, (state, action: PayloadAction<DocumentTemplate[]>) => {
                state.isLoading = false;
                state.templates = action.payload;
            })
            .addCase(fetchDocumentTemplates.rejected, (state, action: any) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(createDocumentTemplate.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(createDocumentTemplate.fulfilled, (state, action: PayloadAction<DocumentTemplate>) => {
                state.isLoading = false;
                state.templates = state.templates.concat(action.payload);
            })
            .addCase(createDocumentTemplate.rejected, (state, action: any) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(updateDocumentTemplate.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(updateDocumentTemplate.fulfilled, (state, action: PayloadAction<DocumentTemplate>) => {
                state.isLoading = false;
                const updatedTemplate = action.payload
                const updatedTemplates = state.templates.map((template) => {
                    return template.id === updatedTemplate.id ? updatedTemplate : template
                });
                state.templates = updatedTemplates;
            })
            .addCase(updateDocumentTemplate.rejected, (state, action: any) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(deleteDocumentTemplate.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(deleteDocumentTemplate.fulfilled, (state, action: PayloadAction<DocumentTemplate[]>) => {
                state.isLoading = false;
                state.templates = action.payload;
            })
            .addCase(deleteDocumentTemplate.rejected, (state, action: any) => {
                state.isLoading = false;
                state.error = action.payload;
            });
    }
});

export default templatesSlice.reducer;